<template>
    <div class="hasLogin" v-if="$i18n.locale == 'zh'">
        <a class="shop" @click="isLang = !isLang" ref="head" :class="{ zh: $i18n.locale == 'zh' }">猛兽商城
        </a>

        <transition name="fade">
            <div class="outbox" v-if="isLang" ref="box">
                <div class="innerbox">
                    <div class="li" v-for="li, index in ul" :key="index" @click="pushShop(li.data)">{{ li.lang }}</div>
                </div>
            </div>
        </transition>
    </div>
</template>
 
<script>
import i18n from "../lang";
//此页为通用页头
export default {
    props: ['ul'],
    inject: ['reload'],
    data() {
        return {
            num: 0,
            dis: "none",
            changeLang: false,
            isLang: false
        };
    },
    mounted() {
        document.addEventListener('click', event => {
            var a = this.$refs.box
            var b = this.$refs.head
            var c = this.$refs.lang
            var d = this.$refs.path
            var e = this.$refs.svg

            if (event.target != a && event.target != b && event.target != c && event.target != d && event.target != e) {
                this.isLang = false
            }
        })
    },
    watch: {
        'changeLang'(oldval, newval) {
            if (this.changeLang == true) {

            }
        },
        // 'i18n.locale'(){

        // }
    },
    methods: {
        setLang(lang) {
            this.showList()


        },
        pushShop(shop) {
            this.showList()
            if (shop == 'tianmao') {
                window.open('https://partyanimals.tmall.com/')
            } else {
                window.open('https://mall.jd.com/index-13161900.html')

            }
        },
        Logout() {
            this.showList()
            this.$store.commit("Logout");
        },
        showList() {
            this.isLang = false
        },
    }
};
</script>
<style lang="scss" scoped>
.shop {
    padding: 0 20px;
    cursor: pointer;
    font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei, sans-serif;
    margin-top: 4px;
}

.hasLogin {
    // position: absolute;
    font-family: 'Nunito-Bold';
    // width: 225px;
    height: 65px;
    border-radius: 18px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;

    .lang {
        display: none;
        font-family: "Nunito-Bold", HYZhengYuan-65W, Microsoft YaHei, sans-serif;
        color: #5b5b5b;
    }

    .outbox {
        position: absolute;
        top: 60px;
        font-family: 'Nunito-Bold', HYZhengYuan-65W, Microsoft YaHei, sans-serif;
        font-size: 16px;
        color: #5c5956;
        line-height: 42px;
        background-color: rgba(255, 255, 255);
        border: 1px solid #e1e0dd;
        box-shadow: 0px 10px 24px 0px rgb(0 0 0 / 8%);
        border-radius: 18px;
        padding: 0px;
        transition: all ease .2s;
        margin-right: -0px;

        // padding: ;
        .innerbox {
            font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei, sans-serif;
            margin: 7px 8px 10px;

            text-align: left;
            border-radius: 14px;
            transition: all .2s ease;

            .li {
                transition: all .4s;
                text-align: center;
                padding: 3px 19px 0;
                margin-bottom: -3px;
                
                border-radius: 12px;
                cursor: pointer;
                min-width: 102px;
                white-space: nowrap;

                &:hover {
                    background-color: #fceaad;
                }

                &:active {
                    background-color: #ffcc00;
                    color: #ffffff;
                }
            }
        }

        z-index: 200;
    }

    .head {
        width: 24px;
        z-index: 100;
        height: 24px;
        cursor: pointer;
        margin-right: -7px;

        &.zh {
            margin-right: -8px;
        }

        svg {
            fill: #5F5F5F;
            transition: all .4s;

            &:hover {

                fill: #f87e35;

            }
        }


    }

}

@media screen and (max-width:1100px) {

    .hasLogin {
        .lang {
            display: block;
            font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei, sans-serif;
            padding-top: 4px;
            cursor: pointer;
        }

        &.phone {
            display: flex;
            flex-direction: row;

            .head {
                margin-right: 8px;

                svg {
                    fill: #5F5F5F;
                    transition: all .4s;

                    &:hover {

                        fill: #5F5F5F;

                    }
                }
            }
        }
    }

    .hasLogin .outbox {
        position: absolute;
        top: -110px;
    }

    .hasLogin .outbox .innerbox .li {
        text-align: center !important;
    }
}
</style>